const formatDate = (dateAsString) => {
  if (!dateAsString) {
    return ""
  }
  const date = new Date(dateAsString)
  return (date.getMonth()+1) + '/' + date.getDate() + '/' + date.getFullYear()
}

const formatDateIntl = (dateStr, withTime) => {
  const format = {
    year: 'numeric',
    month: 'long',
    day: '2-digit'
  }
  if (withTime) {
    format.hour = '2-digit',
    format.minute = '2-digit'
  }
  return dateStr && new Intl.DateTimeFormat('en-US', format).format(new Date(dateStr)) || '(no date)'
}

const isWithin = (dateAsString, from, within) => {
  from ||= new Date()
  const date = new Date(dateAsString)
  if (!within || within == '1.month+1.day') {
    date.setMonth( date.getMonth() + 1);
    date.setDate( date.getDate() + 1);
  } else {
    const count = parseInt(within.split('.')[0])
    const interval = within.split('.')[1]
    if (interval.match(/month/i)) {
      date.setMonth(date.getMonth() + count)
    } else if (interval.match(/day/i)) {
      date.setDate(date.getDate() + count)
    } else if (interval.match(/hour/i)) {
      date.setHours(date.getHours() + count)
    } else if (interval.match(/minute/i)) {
      date.setMinutes(date.getMinutes() + count)
    } else if (interval.match(/second/i)) {
      date.setSeconds(date.getSeconds() + count)
    } else {
      throw new Error(`could not parse interval : ${interval}`)
    }
  }
  return date > from
}

const isWithinMinutes = (dateAsString, from, minutes) => {
  from ||= new Date()
  const date = new Date(dateAsString)
  date.setMinutes( date.getMinutes() + minutes);
  return date > from
}

const isWithinDaysFromNow = (dateAsString, days) => {
  const date = new Date(dateAsString)
  date.setDate( date.getDate() + days);
  return date > new Date()
}

const isWithinOneMonthsAndOneDay = (dateAsString, from) => {
  from ||= new Date()
  const date = new Date(dateAsString)
  date.setMonth( date.getMonth() + 1);
  date.setDate( date.getDate() + 1);
  return date > from
}

const isWithinYearsFromNow = (dateAsString, days) => {
  const date = new Date(dateAsString)
  date.setFullYear( date.getFullYear() + days);
  return date > new Date()
}

const isWithinMonthsFromNow = (dateAsString, months) => {
  const date = new Date(dateAsString)
  date.setMonth( date.getMonth() + months);
  return date > new Date()
}

const twoWeeksAgo = new Date()
twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);

const oneMonthAgo = new Date()
oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

const oneMonthFromNow = new Date()
oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);

const twoMonthsAgo = new Date()
twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);

const sixMonthsAgo = new Date()
sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
sixMonthsAgo.setDate(sixMonthsAgo.getDate() - 1);

const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1);

const tomorrow = new Date()
tomorrow.setDate(tomorrow.getDate() + 1);

export {formatDateIntl, formatDate, isWithin, isWithinDaysFromNow, isWithinYearsFromNow, isWithinMonthsFromNow, isWithinOneMonthsAndOneDay, twoWeeksAgo, yesterday, tomorrow, oneMonthAgo, twoMonthsAgo, sixMonthsAgo, oneMonthFromNow}
